var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Modal",
    {
      ref: "modal",
      attrs: { "hide-body-padding": true },
      on: { show: _vm.onShow, hide: _vm.onHide },
      scopedSlots: _vm._u([
        {
          key: "title",
          fn: function () {
            return [
              _vm._v(_vm._s(_vm.$t("forms.exercisemodal.selectexercise"))),
            ]
          },
          proxy: true,
        },
        {
          key: "under-header",
          fn: function () {
            return [
              _c("section", { staticClass: "modal-card-search" }, [
                _c("div", { staticClass: "field" }, [
                  _c(
                    "div",
                    { staticClass: "control is-expanded has-icons-left" },
                    [
                      _c("input", {
                        ref: "modalSearch",
                        staticClass: "input",
                        attrs: {
                          name: "modalsearch",
                          type: "text",
                          placeholder: _vm.$t("forms.exercisemodal.search"),
                          autocomplete: "off",
                        },
                        domProps: { value: _vm.searchText },
                        on: {
                          input: function ($event) {
                            _vm.searchText = $event.target.value
                          },
                          keydown: _vm.handleKeydown,
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "icon is-small is-left" }, [
                        _c("i", {
                          staticClass: "slicon slicon-fa-magnifying-glass",
                        }),
                      ]),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "field is-grouped is-grouped-multiline" },
                  [
                    _c("div", { staticClass: "control" }, [
                      _c("div", { staticClass: "select is-small" }, [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.bodypart,
                                expression: "bodypart",
                              },
                            ],
                            attrs: {
                              name: "modalbodypart",
                              autocomplete: "off",
                              "aria-label": _vm.$t("forms.howtomodal.bodypart"),
                            },
                            on: {
                              change: function ($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function (o) {
                                    return o.selected
                                  })
                                  .map(function (o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.bodypart = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              },
                            },
                          },
                          [
                            _c("option", { attrs: { value: "" } }, [
                              _vm._v(
                                _vm._s(_vm.$t("enums.bodypart.Any Body Part"))
                              ),
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.bodyparts, function (bodypart) {
                              return _c(
                                "option",
                                { domProps: { value: bodypart } },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("enums.bodypart." + bodypart))
                                  ),
                                ]
                              )
                            }),
                          ],
                          2
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "control" }, [
                      _c("div", { staticClass: "select is-small" }, [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.category,
                                expression: "category",
                              },
                            ],
                            attrs: {
                              name: "modalcategory",
                              autocomplete: "off",
                              "aria-label": _vm.$t("forms.howtomodal.category"),
                            },
                            on: {
                              change: function ($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function (o) {
                                    return o.selected
                                  })
                                  .map(function (o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.category = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              },
                            },
                          },
                          [
                            _c("option", { attrs: { value: "" } }, [
                              _vm._v(
                                _vm._s(_vm.$t("enums.category.Any Category"))
                              ),
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.categories, function (category) {
                              return _c(
                                "option",
                                { domProps: { value: category } },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("enums.category." + category))
                                  ),
                                ]
                              )
                            }),
                          ],
                          2
                        ),
                      ]),
                    ]),
                  ]
                ),
              ]),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm._v(" "),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "exerciseList",
          style: {
            minHeight:
              _vm.exerciseListMinHeight !== null
                ? _vm.exerciseListMinHeight + "px"
                : undefined,
          },
        },
        [
          _vm._l(_vm.limitedExerciseList, function (exercise) {
            return _c("div", { staticClass: "card" }, [
              _c(
                "a",
                {
                  staticClass: "card-content px-4 py-3",
                  staticStyle: { display: "block" },
                  on: {
                    click: function ($event) {
                      return _vm.selectExercise(exercise)
                    },
                  },
                },
                [
                  _c("span", { staticClass: "media" }, [
                    _c("figure", { staticClass: "media-left mr-3" }, [
                      _c("p", { staticClass: "image is-32x32" }, [
                        _c("img", {
                          directives: [
                            {
                              name: "lazy",
                              rawName: "v-lazy",
                              value: exercise.icon_url,
                              expression: "exercise.icon_url",
                            },
                          ],
                          attrs: {
                            alt: exercise.name,
                            width: "32",
                            height: "32",
                          },
                        }),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "media-content" },
                      [
                        _c(
                          "WordHighlighter",
                          { attrs: { query: _vm.searchText } },
                          [_vm._v(_vm._s(exercise.name))]
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "tag is-small ml-1" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("enums.bodypart." + exercise.bodypart)
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        typeof exercise.percentile !== "undefined"
                          ? _c(
                              "span",
                              { staticClass: "tag is-small" },
                              [
                                _c("Stars", {
                                  attrs: { percentile: exercise.percentile },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        exercise.user_id
                          ? _c("span", { staticClass: "tag is-small" }, [
                              _vm._v("Custom"),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        exercise.aliases.length > 0
                          ? [
                              _c("br"),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "has-text-black is-size-7" },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.$t(
                                          "forms.exercisemodal.alsoknownas"
                                        )
                                      ) +
                                      "\n                  "
                                  ),
                                  _c(
                                    "WordHighlighter",
                                    { attrs: { query: _vm.searchText } },
                                    [
                                      _vm._v(
                                        _vm._s(exercise.aliases.join(", "))
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]
                          : _vm._e(),
                      ],
                      2
                    ),
                  ]),
                ]
              ),
            ])
          }),
          _vm._v(" "),
          _vm.filteredExerciseList.length < 1
            ? [
                _vm.loading
                  ? _vm._l(10, function (index) {
                      return _c("div", { staticClass: "card" }, [
                        _c(
                          "div",
                          {
                            staticClass: "card-content px-4 py-3",
                            staticStyle: {
                              display: "block",
                              "font-family": "cursive",
                            },
                          },
                          [
                            _c("span", { staticClass: "media" }, [
                              _c("span", { staticClass: "media-left" }, [
                                _c("span", {
                                  staticClass:
                                    "icon is-left has-background-grey-lighter p-4",
                                  staticStyle: { "border-radius": "2px" },
                                }),
                              ]),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "media-content" },
                                [
                                  _c(
                                    "span",
                                    { staticStyle: { display: "flex" } },
                                    [
                                      _c("span", {
                                        staticClass:
                                          "p-2 has-background-grey-lighter",
                                        staticStyle: {
                                          flex: "1",
                                          "border-radius": "2px",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("span", {
                                        staticClass: "tag is-small ml-1",
                                        staticStyle: { width: "5rem" },
                                      }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  index % 3 == 1
                                    ? [
                                        _c("div", {
                                          staticClass:
                                            "p-2 mt-2 has-background-grey-lighter",
                                          staticStyle: {
                                            width: "100%",
                                            "border-radius": "2px",
                                          },
                                        }),
                                      ]
                                    : _vm._e(),
                                ],
                                2
                              ),
                            ]),
                          ]
                        ),
                      ])
                    })
                  : _c("div", { staticClass: "card" }, [
                      _c("div", { staticClass: "card-content px-4 py-3" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("forms.exercisemodal.noexercises")) +
                            "\n        "
                        ),
                      ]),
                    ]),
              ]
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card-content px-4 pt-3 pb-6" }, [
              _c("div", { staticClass: "buttons" }, [
                _c(
                  "button",
                  {
                    staticClass: "button",
                    attrs: { type: "button", disabled: !_vm.showButton },
                    on: { click: _vm.increaseLimit },
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("forms.exercisemodal.moreexercises")) +
                        "\n          "
                    ),
                  ]
                ),
              ]),
            ]),
          ]),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }